import Image from 'next/image';

const CARD_SIZES = {
  large: { width: 155, height: 239 },
  small: { width: 100, height: 154 },
} as const;

export interface BenefitCardProps {
  imageUrl: string;
  size: 'large' | 'small';
}

export default function BenefitCard({ imageUrl, size }: BenefitCardProps) {
  const { width, height } = CARD_SIZES[size];

  return (
    <Image
      src={imageUrl}
      alt="benefit card"
      width={width}
      height={height}
    />
  );
}
